/* tslint:disable */
/* eslint-disable */
/**
 * True one Services API
 * True one service for form Builder
 *
 * The version of the OpenAPI document: 4.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SectionAnswerDto } from './SectionAnswerDto';
import {
    SectionAnswerDtoFromJSON,
    SectionAnswerDtoFromJSONTyped,
    SectionAnswerDtoToJSON,
} from './SectionAnswerDto';

/**
 * 
 * @export
 * @interface SubmitFormRequest
 */
export interface SubmitFormRequest {
    /**
     * 
     * @type {Array<SectionAnswerDto>}
     * @memberof SubmitFormRequest
     */
    answers?: Array<SectionAnswerDto>;
    /**
     * 
     * @type {string}
     * @memberof SubmitFormRequest
     */
    operatorId?: string;
}

/**
 * Check if a given object implements the SubmitFormRequest interface.
 */
export function instanceOfSubmitFormRequest(value: object): value is SubmitFormRequest {
    return true;
}

export function SubmitFormRequestFromJSON(json: any): SubmitFormRequest {
    return SubmitFormRequestFromJSONTyped(json, false);
}

export function SubmitFormRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubmitFormRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'answers': json['answers'] == null ? undefined : ((json['answers'] as Array<any>).map(SectionAnswerDtoFromJSON)),
        'operatorId': json['operatorId'] == null ? undefined : json['operatorId'],
    };
}

export function SubmitFormRequestToJSON(value?: SubmitFormRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'answers': value['answers'] == null ? undefined : ((value['answers'] as Array<any>).map(SectionAnswerDtoToJSON)),
        'operatorId': value['operatorId'],
    };
}

